import React from 'react';
import {
	AcademicPartnerContentItemCategory,
	GetMemberProgramQuery,
} from 'src/graphqlTypes/catalogServiceTypes';
import { Accordion, Typography } from '@guildeducationinc/recess';
import { trackEvent } from 'src/services/analytics';
import styles from './HowToPrepare.module.scss';

interface Props {
	program: GetMemberProgramQuery['memberProgram'];
}

export const HowToPrepare: React.FC<Props> = ({ program }) => {
	const preparationSteps = program?.studentFacingAcademicPartner.contentItems.filter(
		item => item.category === AcademicPartnerContentItemCategory.APPLICATION_PREP
	);

	if (!preparationSteps.length) {
		return null;
	}

	const prepsTitle = ({ isOpen }) => {
		if (isOpen) {
			trackEvent('Clickable', {
				tag: 'applications_section',
				text: 'how_to_prepare',
				type: 'accordion',
			});
		}
		return <Typography variant='title3'>How to prepare</Typography>;
	};

	return (
		<Accordion title={prepsTitle}>
			<ol className={styles.stepsList}>
				{preparationSteps.map(({ body }) => (
					<li data-testid='preps-item' key={body}>
						<Typography variant='body1'>{body}</Typography>
					</li>
				))}
			</ol>
		</Accordion>
	);
};
